(() => {
  angular.module('finance').component('makePaymentCartComponent', {
    templateUrl: require('./makePaymentCart.component.html'),
    controller: MakePaymentCartComponent,
    controllerAs: 'vm',
    bindings: {
      selectedInvoices: '=',
      pageState: '=',
      calculateTotalAmount: '<',
      keyId: '<',
      orderId: '<',
      requestId: '=',
      orderInvoices: '<',
    },
  });

  MakePaymentCartComponent.$inject = ['$rootScope', 'abp.services.finance.curlec', 'appSession'];

  function MakePaymentCartComponent($root, curlecSvc, appSession) {
    const vm = this;

    vm.loading = 0;
    vm.totalAmount = 0;
    vm.currencyCode = 'MYR';
    vm.isModalOpen = false;

    vm.remove = remove;
    vm.cancel = cancel;
    vm.checkout = checkout;
    vm.getDateString = getDateString;

    const isResumeOrder = !!vm.orderId;

    init();

    function init() {
      const invoices = isResumeOrder ? vm.orderInvoices : vm.selectedInvoices;

      vm.totalAmount = vm.calculateTotalAmount(invoices);
      loadRazorpayScript();
    }

    function cancel() {
      vm.pageState = 0;
    }

    function checkout() {
      // Checkout hands the browser over to the bank and comes back through
      // /Curlec/CurlecCallbackHandler, which only runs if the payer returns. Closing the tab
      // before then leaves the payment taken by the bank but not recorded here (HM-11341).
      // Warn while we still have the payer's attention: once they leave for the bank this
      // page is no longer running and can say nothing.

      abp.message.confirm(
        App.localize('CurlecDoNotCloseBrowserWarning'),
        App.localize('BeforeYouContinue'),
        (confirmed) => {
          if (confirmed) {
            startCheckout();
          }
        }
      );
    }

    function startCheckout() {
      // Add the transaction number of the selected invoices to notes and join with a comma and space.

      const invoiceIds = _.map(vm.selectedInvoices, 'transactionNumber').join(', ');

      let options = {
        key: '',
        name: '',
        description: '',
        order_id: '',
        image: '',
        prefill: {
          name: '',
          email: '',
          contact: '',
        },
        hidden: {
          email: true,
          contact: true,
        },
        notes: {
          tenantName: appSession.tenant.name,
          tenantCode: appSession.tenant.tenancyName,
          invoicePaid: invoiceIds,
        },
        theme: {
          color: '#3399cc',
        },
        callback_url: $root.resolveAppPath('/Curlec/CurlecCallbackHandler'),
        redirect: true,
      };
      // Boolean whether to show image inside a white frame. (default: true)
      options.theme.image_padding = false;
      options.modal = {
        // Boolean indicating whether pressing escape key
        // should close the checkout form. (default: true)
        escape: true,
        // Boolean indicating whether clicking translucent blank
        // space outside checkout form should close the form. (default: false)
        backdropclose: false,
        // Actions taken when the modal is closed.
        ondismiss: () => {
          vm.isModalOpen = false;
        },
      };

      const inputInvoices = [];
      const inputBillingAccountIds = [];

      _.forEach(vm.selectedInvoices, (selectedInvoice) => {
        inputInvoices.push({
          id: selectedInvoice.id,
          appliedAmount: selectedInvoice.outstandingAmount,
        });
        inputBillingAccountIds.push(selectedInvoice.billingAccountId);
      });

      // Create a new order if orderId is empty.

      if (!vm.orderId) {
        const input = {
          amount: vm.totalAmount,
          currencyCode: vm.currencyCode,
          invoices: inputInvoices,
          billingAccountIds: _.uniq(inputBillingAccountIds),
          requestId: vm.requestId,
          notes: {
            tenantName: appSession.tenant.name,
            tenantCode: appSession.tenant.tenancyName,
            invoicePaid: invoiceIds,
          },
        };

        vm.loading += 1;
        curlecSvc
          .createOrder(input)
          .success((data) => {
            vm.orderId = data.orderId;
            vm.keyId = data.keyId;

            lockOrder(vm.orderId);
            openModal(options);
          })
          .finally(() => {
            vm.loading -= 1;
          });
      } else {
        openModal(options);
      }
    }

    function openModal(options) {
      options.key = vm.keyId;
      options.order_id = vm.orderId;
      var rzp = new Razorpay(options);
      rzp.open();
      vm.isModalOpen = true;
    }

    function remove(invoice) {
      let index = vm.selectedInvoices.map((invoice) => invoice.id).indexOf(invoice.id);
      vm.selectedInvoices.splice(index, 1);
      vm.totalAmount = vm.calculateTotalAmount(vm.selectedInvoices);
    }

    function loadRazorpayScript() {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      document.head.appendChild(script);
    }

    function getDateString(date) {
      return App.getDateString(moment.utc(date));
    }

    function lockOrder(orderId) {
      vm.orderInvoices = vm.selectedInvoices.map((invoice) => ({
        transactionNumber: invoice.transactionNumber,
        outstandingAmount: invoice.outstandingAmount,
        date: invoice.date,
        category: invoice.category,
        currencyCode: invoice.currencyCode,
      }));
    }
  }
})();
